import { ApprovalProcessStepViewModel, ApprovalProcessTagBasedStepViewModel } from '@ail/orders-api'
import { useTranslation } from 'react-i18next'
import { printDate } from '../../../../helpers/Utils'
import './ApprovalProcessSteps.scss'
export function ApprovalProcessSteps(props: {
  steps: ApprovalProcessStepViewModel[] | ApprovalProcessTagBasedStepViewModel[]
}) {
  const { t } = useTranslation('common')

  return (
    <table className="approval-process-steps">
      <thead>
        <tr>
          <th className="ApproveStep">{t('STEP')}</th>
          <th className="ApproveUser">{t('USER_NAME')}</th>
          <th className="ApproveDate">{t('DATE')}</th>
          <th className="ApproveNote">{t('NOTE')}</th>
        </tr>
      </thead>
      <tbody>
        {props.steps.map(
          (row, index) =>
            row.status && (
              <tr key={index}>
                <td
                  style={
                    row.status === 'Pending' && props.steps[index - 1]?.status === 'Approved'
                      ? { borderColor: '#f7b010' }
                      : row.status === 'Declined'
                      ? { borderColor: '#FF0000' }
                      : row.status === 'Approved'
                      ? undefined
                      : { borderColor: 'gray', color: 'gray' }
                  }
                  className="ApproveStep"
                  key={row.step}
                >
                  {row.status === 'Pending' && props.steps[index - 1]?.status === 'Approved' ? (
                    <i className="icon-pending"></i>
                  ) : row.status === 'Declined' ? (
                    <i className="icon-denied"></i>
                  ) : (
                    row.step
                  )}
                </td>
                <td className="ApproveUser" key={row.userDisplayName}>
                  <span className="textEllipsis">{row.status === 'Pending' ? null : row.userDisplayName}</span>
                </td>
                <td className="ApproveDate" key={printDate(row.timestamp)}>
                  {row.status !== 'Pending' ? printDate(row.timestamp, true) : ''}
                </td>
                <td className="ApproveNote tooltip">
                  <div className="textEllipsis">{Object.values(row.notes).join('; ')}</div>
                  <div className="tooltipParent">
                    <span className="tooltipText">{Object.values(row.notes).join('; ')}</span>
                  </div>
                </td>
              </tr>
            )
        )}
      </tbody>
    </table>
  )
}
